export default __webpack_public_path__ + "45ca7c34f254076843c9a7a6083b206e.png";